import simplify from 'simplify-js'

import { PaneArea } from '../../../types/shared'
import Brush, { BrushPoints, IBrushAttrs } from '../../canvas/brush/brush_v1'
import PaneModel from '../../models/pane'

type Area = PaneArea
type Attrs = IBrushAttrs
type PartialAttrs = Partial<Attrs>

class BrushCreator extends Brush<IBrushAttrs> {
  isCreator = true

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super({ ...values, points: [[startArea.x, startArea.y]] }, model)

    this.bind('mousemove', this.onMouseMove)
    this.bind('mouseup', this.onMouseUp)
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  simplifyPolyline = (pointsArray: BrushPoints): BrushPoints =>
    simplify(
      pointsArray.map(([x, y]) => ({ x: this.fx(x), y: this.fy(y) })),
      1
    ).map(({ x, y }) => [this.model.scale.x.invert(x), this.model.scale.y.invert(y)])

  onMouseMove = (area: Area) => {
    this.attrs.points.push([area.x, area.y])
    if (this.attrs.points.length > 5) {
      this.attrs.points = this.simplifyPolyline(this.attrs.points)
    }
    this.trigger('change')
  }

  onMouseUp = () => {
    this.release()
    this.replaceMyself(Brush.fromObject<Brush>(this.attrs, this.model))
    this.toolsCallback()
  }
}

export default BrushCreator
